<template>
  <v-app>
    <app-drawer style="position:fixed;" />
    <div id="app">
      <router-view />
    </div>
  </v-app>
</template>

<script>
import AppDrawer from "./components/AppDrawer";

export default {
  name: "App",
  components: {
    AppDrawer
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  background: #f9f9f9;
  width: 100%;
  height: 100%;
}

a {
  text-decoration: none;
  color: #222222;
}

.page-container {
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding-top: 55px;
}

button {
  cursor: pointer;
}

/** css variables */
:root {
  --primary-color: #3a3a3a;

  /** 수직 정렬 */
  --header-z-index: 2;
  --drawer-z-index: 3;
}

/** animations */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/** override vuetify */
.v-progress-circular__overlay {
  transition-timing-function: linear !important;
  transition-duration: 0.25s !important;
}
/** 
 * css breakpoints 
 * small: 576px
 * medium: 768px
 * large: 992px
 * extra large: 1200px
*/
</style>
